import React from "react";
import Header from "../header";
import Footer from "../footer";
import Sidebar from "../sidebar";
import SubHeader from "../subHeader";
import UserRoute from "../ProtectedRoute/UserProtecTedRoute";
import SubHeader2 from "../../components/subHeader2";

const Layout = ({ children, sidebarContent }) => {
  return (
    <UserRoute>
      <header>
        <Header />
      </header>
      <SubHeader />
      <main style={{ minHeight: "80vh" }}>
        <div className="row">
          <div
            className="col-lg-3 col-md-12 col-sm-12"
            style={{ backgroundColor: "#E6EBF3" }}
          >
            {sidebarContent}
          </div>
          <div className="col-lg-9 col-md-12 col-sm-12">{children}</div>
        </div>
      </main>

      <footer>
        <Footer />
      </footer>
    </UserRoute>
  );
};

export default Layout;
